(function () {
  const FX_URL = 'https://api.exchangerate-api.com/v4/latest/MXN';
  const CACHE_KEY = 'fx_mxn_rates_v1';
  const CACHE_TTL = 60 * 60 * 1000; // 1 hora

  async function getVisitorCurrency() {
    // Shopify native detection (mejor)
    const url = window.Shopify?.routes?.root
      ? (window.Shopify.routes.root + 'browsing_context_suggestions.json?currency[enabled]=true&country[enabled]=true')
      : '/browsing_context_suggestions.json?currency[enabled]=true&country[enabled]=true';

    const r = await fetch(url, { credentials: 'same-origin' });
    const data = await r.json();

    // Si Shopify devuelve sugerencia de moneda, úsala
    const suggestedCurrency =
      data?.suggestions?.[0]?.parts?.currency?.handle;

    // Si no hay sugerencia, como mínimo tenemos país detectado y podrías mapear país->moneda tú (ej: ES->EUR).
    if (suggestedCurrency) return suggestedCurrency;

    const country = data?.detected_values?.country?.handle;
    
    const map = {
      ES: 'EUR', FR: 'EUR', DE: 'EUR', IT: 'EUR',  PT: 'EUR', 
      US: 'USD', CA: 'CAD', MX: 'MXN',
      AR: 'ARS', BR: 'BRL', CL: 'CLP', CO: 'COP', PE: 'PEN', UY: 'UYU', PY: 'PYG', BO: 'BOB', VE: 'VES', EC: 'USD',
      DO: 'DOP', CR: 'CRC', GT: 'GTQ', HN: 'HNL', NI: 'NIO', PA: 'PAB', SV: 'USD', CU: 'CUP'
    };

    const code = map[country] || 'USD';

    const selectors = document.querySelectorAll('.currency-selector');
    if (selectors.length) {
      selectors.forEach(el => {
        el.textContent = code;
      });
    }
    
    return code;
  }

  function loadCachedRates() {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const { t, rates } = JSON.parse(raw);
      if (Date.now() - t > CACHE_TTL) return null;
      return rates;
    } catch (e) {
      return null;
    }
  }

  async function getRatesMXN() {
    const cached = loadCachedRates();
    if (cached) return cached;

    const r = await fetch(FX_URL);
    const data = await r.json();
    // exchangerate-api v4 devuelve { rates: {...} }
    const rates = data.rates;

    localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), rates }));
    return rates;
  }

  function formatMoney(amount, currency) {
    // Formato según idioma del navegador
    return new Intl.NumberFormat(navigator.language || 'es-ES', {
      style: 'currency',
      currency
    }).format(amount);
  }

  async function convertAllPrices() {
    const targets = document.querySelectorAll('.js-money[data-money-cents]');
    if (!targets.length) return;

    const visitorCurrency = await getVisitorCurrency();
    if (!visitorCurrency || visitorCurrency === 'MXN') return;

    const rates = await getRatesMXN();
    const rate = rates[visitorCurrency];
    if (!rate) return;

    targets.forEach(el => {
      const cents = parseInt(el.dataset.moneyCents, 10);
      if (Number.isNaN(cents)) return;

      const mxn = cents / 100;
      const converted = mxn * rate;
      const formattedPrice = formatMoney(converted, visitorCurrency);

      const title = el.getAttribute('title');
      const prefix = title ? `${title} - ` : '';

      el.textContent = prefix + formattedPrice;
      el.dataset.moneyCurrency = visitorCurrency;
    });
  }

  // Ejecuta al cargar
  document.addEventListener('DOMContentLoaded', convertAllPrices);

  // Hacerla accesible globalmente
  window.convertAllPrices = convertAllPrices;

})();
